import React, {useRef} from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import AdminDashboard from "./component/AdminDashboard";
import Home from "./component/Letuslogin";
import CourseContent from "./component/CreateContent";
import EditContent from "./component/EditContent";
import ShowContent from "./component/ShowContent";
import EditDays from "./component/EditDays";
import ContactRequests from "./component/ContactRequest";
import CourseBuyer from './component/CourseBuyer';
import LoginData from "./component/LoginData";
import ShowProfile from "./component/ShowProfiles";
import VisitorData from "./component/VisitorData";
import VisitorContact from "./component/VisitorContact";
import OurDiary from "./component/OurDiary";
import StudyMaterial from "./component/StudyMaterial"
import TextEditor from "./component/TextEditor";
import AdminRoutesManager from "./component/AdminRoutesManager";
import PdfMaker from "./component/PdfMaker";
// import VoiceCall from "./component/Voicecall";
import SendEmail from "./PersonalTalk/SendEmail";
// import ContentForm from "./component/ContentForm";

// chatting app
import ChattingHome from './parishram/Pages/ChattingHome'
import { Send } from "lucide-react";
// import ChattingEditProfile from './parishram/Pages/ChattingEditProfile';
// import ChattingPrivateChat from './parishram/Pages/ChattingPrivateChat';
// import ChattingStartGame from './parishram/Pages/ChattingStartGame';

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/createcontent" element={<CourseContent />} /> */}
          <Route path="/admindashboard" element={<AdminDashboard />} />
          {/* <Route path="/show-content" element={<ShowContent />} /> */}
          {/* <Route path="/editcontent" element={<EditContent />} /> */}
          {/* <Route path="/editdays" element={<EditDays />} /> */}
          {/* <Route path="/contactrequests" element={<ContactRequests />} /> */}
          {/* <Route path="/coursebuyers" element={<CourseBuyer />} /> */}
          {/* <Route path="/logindata" element={<LoginData />} /> */}
          {/* <Route path="/showprofile" element={<ShowProfile />} /> */}
          {/* <Route path="/visitordata" element={<VisitorData />} /> */}
          {/* <Route path="/visitorcontact" element={<VisitorContact />} /> */}
          <Route path="/admin/ourdiary" element={<OurDiary />} />
          <Route path="/admin/texteditor" element={<TextEditor />} />
          {/* <Route path="/admin/studymaterial" element={<StudyMaterial />} /> */}
          {/* <Route path="/admin/adminroutemannager" element={<AdminRoutesManager />} /> */}
          <Route path="/admin/pdfmaker" element={<PdfMaker />} />
          {/* <Route path="/admin/contentform" element={<ContentForm />} /> */}
          {/* chatting app */}
          <Route path='/chattinghome' element={<ChattingHome />}></Route>
          {/* <Route path='/voicecall' element={<VoiceCall />}></Route> */}
          <Route path='/sendemail' element={<SendEmail />}></Route>

        {/* <Route path='/chattingeditprofile' element={<ChattingEditProfile />}></Route> */}
        {/* <Route path='/chattingprivatechat' element={<ChattingPrivateChat />}></Route> */}
        {/* <Route path='/chattingstartgame' element={<ChattingStartGame />}></Route> */}
        </Routes>
      </Router>
    </>
  );
};

export default App;
